import RAPIER from '@dimforge/rapier3d-compat';
import type { Vector3 } from '../types';

// ============================================
// PhysicsWorld - Mundo físico con Rapier3D
// ============================================

export class PhysicsWorld {
  private world: RAPIER.World | null = null;
  private initialized = false;

  async init(): Promise<void> {
    await RAPIER.init();
    this.world = new RAPIER.World({ x: 0, y: -9.81, z: 0 });
    this.initialized = true;
    console.log('[PhysicsWorld] Motor físico inicializado');
  }

  update(_deltaTime: number): void {
    if (!this.world) return;
    this.world.step();
  }

  addStaticBox(position: Vector3, halfExtents: Vector3): void {
    if (!this.world) return;

    const bodyDesc = RAPIER.RigidBodyDesc.fixed().setTranslation(
      position.x,
      position.y,
      position.z
    );
    const body = this.world.createRigidBody(bodyDesc);

    const colliderDesc = RAPIER.ColliderDesc.cuboid(
      halfExtents.x,
      halfExtents.y,
      halfExtents.z
    );
    this.world.createCollider(colliderDesc, body);
  }

  addDynamicBox(
    position: Vector3,
    halfExtents: Vector3,
    mass: number = 1
  ): RAPIER.RigidBody | null {
    if (!this.world) return null;

    const bodyDesc = RAPIER.RigidBodyDesc.dynamic()
      .setTranslation(position.x, position.y, position.z)
      .setLinearDamping(0.5)
      .setAngularDamping(0.5);
    const body = this.world.createRigidBody(bodyDesc);

    const colliderDesc = RAPIER.ColliderDesc.cuboid(
      halfExtents.x,
      halfExtents.y,
      halfExtents.z
    )
      .setMass(mass)
      .setFriction(0.8)
      .setRestitution(0.1);

    this.world.createCollider(colliderDesc, body);
    return body;
  }

  createCharacterController(offset: number = 0.05): RAPIER.KinematicCharacterController | null {
    if (!this.world) return null;
    return this.world.createCharacterController(offset);
  }

  dispose(): void {
    if (this.world) {
      this.world.free();
      this.world = null;
    }
    this.initialized = false;
  }

  isInitialized(): boolean {
    return this.initialized;
  }

  getWorld(): RAPIER.World | null {
    return this.world;
  }
}
